import React from "react";

export default function Slider(props) {
  return (
    <div
      style={{
        width: props.width,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        display: props.slider ? "block" : "none",
      }}
      className="designPopup"
    >
      <header>
        <h3 style={{ textAlign: "center", position: "relative", margin: 0 }}>
          {props.heading}{" "}
        </h3>
      </header>
      {props.children}
      <a
        href="#"
        className="cd-panel-close glyphicon glyphicon-remove"
        onClick={(e) => {
          props.closeSlider();
        }}
      >
        Close
      </a>
    </div>
  );
}
